var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.279,
    height: 22.998,
    viewBox: "0 0 32.279 22.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25858",
    "data-name": "Path 25858",
    d: "M48.41,30.913a6.772,6.772,0,0,0-1.244-3.1,4.471,4.471,0,0,0-3.134-1.325c-4.378-.317-10.944-.317-10.944-.317h-.013s-6.566,0-10.944.317A4.471,4.471,0,0,0,19,27.809a6.766,6.766,0,0,0-1.243,3.1,47.211,47.211,0,0,0-.313,5.062v2.373a47.2,47.2,0,0,0,.313,5.062A6.766,6.766,0,0,0,19,46.516a5.3,5.3,0,0,0,3.449,1.337c2.5.24,10.635.315,10.635.315s6.573-.01,10.95-.326a4.475,4.475,0,0,0,3.134-1.325,6.772,6.772,0,0,0,1.244-3.1,47.444,47.444,0,0,0,.312-5.062V35.975a47.458,47.458,0,0,0-.312-5.062M29.851,41.224V32.435l8.451,4.41Z",
    transform: "translate(-16.941 -25.668)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeOutline);
export default __webpack_public_path__ + "static/media/youtube-outline.eef68994f68c183afba01ab8856b7b90.svg";
export { ForwardRef as ReactComponent };